import {Button} from '@mantine/core';
import type {FC} from 'react';
import type {WorkAttractiveConditionType} from '../../../../../core/entities/company/schema';
import {cn} from '../../../../../lib/classname';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {
  ENTRY_BUTTON_ID,
  ENTRY_BUTTON_TEXT_SIZE,
  GradientEntryButton,
} from '../../../../../shared/components/EntryButton/GradientEntryButton';
import {buildCompanyFollowGtmContent} from '../../../../../shared/services/buildCompanyFollowGtmContent';
import {FollowCompanyButton} from '../../FollowButton';
import {AttractiveConditions} from './AttractiveConditions';

type Props = {
  companyLogoURL?: string;
  companyName: string;
  industryName: string;
  isFollowed: boolean;
  companyId: number;
  companyFollowerCount: number;
  followCount: number;
  onFollow: () => void | Promise<void>;
  recruitingFairRegistrationURL?: string;
  entryURL?: string;
  workAttractiveConditions?: WorkAttractiveConditionType[];
  className?: string;
};
export const CompanyHeaderPC: FC<Props> = ({
  companyLogoURL,
  companyName,
  industryName,
  isFollowed,
  companyId,
  companyFollowerCount,
  followCount,
  onFollow,
  recruitingFairRegistrationURL,
  entryURL,
  workAttractiveConditions,
  className,
}) => {
  return (
    <div
      className={cn(
        'p-16 flex pc:justify-between items-center bg-white-1 rounded-16 shadow-card',
        className,
      )}
    >
      <div className="flex items-center">
        {companyLogoURL && (
          <img
            src={companyLogoURL}
            alt={`${companyName}のロゴ`}
            className="w-[48px] h-[36px] hidden pc:block"
          />
        )}
        <div className="px-16 gap-8 flex- flex-col">
          <h1 className="font-bold">{companyName}</h1>
          <div className="text-sm">{industryName}</div>
          {workAttractiveConditions && (
            <AttractiveConditions
              workAttractiveConditions={workAttractiveConditions}
            />
          )}
        </div>
      </div>
      <div className="flex justify-end gap-16 h-48">
        <FollowCompanyButton
          companyId={companyId}
          initial={{
            followerCount: companyFollowerCount,
            isFollowed,
          }}
          hasPlus={false}
          className="w-[128px]"
          controlled={{
            isFollowed,
            followCount,
            onFollow,
          }}
          dataGtmContent={buildCompanyFollowGtmContent({
            companyId,
            companyName,
            location: 'company-detail',
          })}
        />
        {entryURL && (
          <GradientEntryButton
            entryUrl={entryURL}
            id={ENTRY_BUTTON_ID.COMPANY_ENTRY_MAIN}
            size={ENTRY_BUTTON_TEXT_SIZE.MD}
            className="w-[144px] h-full"
            withShadow
            companyId={companyId}
            companyName={companyName}
          />
        )}
        {recruitingFairRegistrationURL && (
          <CommonLink
            href={recruitingFairRegistrationURL}
            target="_blank"
            rel="noopener noreferrer"
            id="recruiting_info_entry_fair_button"
          >
            <Button className="px-36 h-full bg-white text-primary-1 border-primary-1 rounded-[8px] text-sm font-bold hover:ease-in-out hover:duration-300">
              <span className="text leading block w-full text-center font-bold">
                説明会を予約
              </span>
            </Button>
          </CommonLink>
        )}
      </div>
    </div>
  );
};
